import { render } from "./ProductCardComponent.vue?vue&type=template&id=ce112212"
import script from "./ProductCardComponent.vue?vue&type=script&lang=js"
export * from "./ProductCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__